<template>
	<div class="dashboard">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Admin Dashboard</h5>
				</b-col>				
			</b-row>
			
		<b-container fluid class="mt-3">
		
		
		
			<b-row class="px-2">
				<!--<b-col class="px-2">
				
					<b-card img-src="../../assets/icons/crm.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Product Request</h6>
						<b-card-text>
							{{total_products_request}} <b-link block v-b-toggle.productR variant="info"> - </b-link>  
						</b-card-text>
					</b-card>
					<b-collapse id="productR"  accordion="my-accordion" role="tabpanel">
						<b-card-body>
						  <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
						  <b-card-text>{{ text }}</b-card-text>
						</b-card-body>
				   </b-collapse>
					
				</b-col> -->
				<b-col lg="3" md="3" sm="6" >
					<!-- <b-link href="/admin/sellers"></b-link>-->
						<!-- <b-card img-src="../../assets/icons/t-shirt.svg" img-alt="Card image" img-left class="info-box mb-3"> -->
						<b-card no-body class="overflow-hidden p-1">
							<!-- <h6>Total Sellers</h6>
							<b-card-text>
								{{total_seller}}  <b-link block v-b-toggle.totalSeller variant="info"> - </b-link> 
							</b-card-text> -->
							<b-row no-gutters>
							 
							  <b-col md="8">
								<b-card-body >
									<h6>Total Sellers</h6>
								  <b-card-text>
										{{sellerMarkating.totalSeller}}  
								  </b-card-text>
								</b-card-body>
							  </b-col>
							   <b-col md="4" class="text-center borderLeft">
										<b-badge pill variant="success" v-b-tooltip.hover title="Active">{{sellerMarkating.activeSeller}}</b-badge>
										<br/>
									<b-badge pill variant="danger" v-b-tooltip.hover title="Deactivated" >{{sellerMarkating.deactiveSeller}}</b-badge>
									
							  </b-col>
							</b-row>
							
							<footer class="card-footer p-0 mt-1">
								<b-row no-gutters>
									<b-col md="6" class="text-center ">	
										<b-link href="/admin/sellers" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
										</b-link>
									</b-col>
								   <b-col md="6" class="text-center">
										
										<b-link block v-b-toggle.totalSeller variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
								  </b-col>
								</b-row>
									<b-collapse id="totalSeller"  accordion="my-accordion" role="tabpanel">
								<b-card-body>
								   <b-list-group >
									  <b-list-group-item>New : <div class="textCount" > {{sellerMarkating.newSeller}} </div> </b-list-group-item>
									  <b-list-group-item>Approved : <div class="textCount" >{{sellerMarkating.activeSeller}}  </div></b-list-group-item>
									  <b-list-group-item>Un-logged :<div class="textCount" > {{sellerMarkating.unloginSeller}} </div></b-list-group-item>
									</b-list-group>
								</b-card-body>
						  </b-collapse>	
							</footer>
						</b-card>
						
				</b-col>
				<b-col lg="3" md="3" sm="6" >
					<b-card no-body class="overflow-hidden p-1">
						<b-row no-gutters>
						  <b-col md="8">
							<b-card-body >
								<h6>Total {{$root.INFLUENCER_TEXT}}</h6>
							  <b-card-text>
									<!-- {{total_agent}} --> {{agentMarkating.totalAgent}}
							  </b-card-text>
							</b-card-body>
						  </b-col>
						   <b-col md="4" class="text-center borderLeft">
									<b-badge pill variant="success" v-b-tooltip.hover title="Active">{{agentMarkating.activeAgent}}</b-badge>
									<br/>
								<b-badge pill variant="danger" v-b-tooltip.hover title="Deactivated"  >{{agentMarkating.deactiveAgent}}</b-badge>
						  </b-col>
						</b-row>
						<footer class="card-footer p-0 mt-1">
							<b-row no-gutters>
								<b-col md="6" class="text-center ">	
									<b-link href="/admin/agents" style="font-size:12px;">
									<b-iconstack style="font-size:12px;">
									  <b-icon stacked icon="square"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
									</b-iconstack>
									</b-link>
								</b-col>
							   <b-col md="6" class="text-center">
									
									<b-link block v-b-toggle.totalAget variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
							  </b-col>
							</b-row>
								<b-collapse id="totalAget"  accordion="my-accordion" role="tabpanel">
								<b-card-body>
								   <b-list-group >
									  <b-list-group-item>New : <div class="textCount" > {{agentMarkating.newAgent}} </div> </b-list-group-item>
									  <b-list-group-item>Approved : <div class="textCount" > {{agentMarkating.activeAgent}} </div></b-list-group-item>
									  <b-list-group-item>Un-logged :<div class="textCount" > {{agentMarkating.unloginAgent}} </div></b-list-group-item>
									</b-list-group>
								</b-card-body>
							</b-collapse>	
						</footer>
					</b-card>

						
						
					
				</b-col>
				<b-col  lg="3" md="3" sm="6" class="px-2">
					<b-card no-body class="overflow-hidden p-1">
						<b-row no-gutters>
						  <b-col md="8">
							<b-card-body >
								<h6>Total Customers</h6>
							  <b-card-text>
									{{customerDataM.totalCustomer}}
							  </b-card-text>
							</b-card-body>
						  </b-col>
						   <b-col md="4" class="text-center borderLeft">
									<b-badge pill variant="success" v-b-tooltip.hover title="Active">{{customerDataM.totalCustomer}}</b-badge>
									<br/>
								<b-badge pill variant="danger" v-b-tooltip.hover title="Deactivated" >0</b-badge>
						  </b-col>
						</b-row>
						<footer class="card-footer p-0 mt-1">
							<b-row no-gutters>
								<b-col md="6" class="text-center ">	
									<b-link href="/admin/customers" style="font-size:12px;">
									<b-iconstack style="font-size:12px;">
									  <b-icon stacked icon="square"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
									  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3"></b-icon>
									  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
									</b-iconstack>
									</b-link>
								</b-col>
							   <b-col md="6" class="text-center">
									
									<b-link block v-b-toggle.totalCustomer variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
							  </b-col>
							</b-row>
								<b-collapse id="totalCustomer"   accordion="my-accordion" role="tabpanel">
								<b-card-body>
								   <b-list-group >
									  <!--<b-list-group-item>New : <div class="textCount" > 10 </div> </b-list-group-item>
									  <b-list-group-item>Approved : <div class="textCount" > 10 </div></b-list-group-item> -->
									  <b-list-group-item>Un-logged :<div class="textCount" > {{customerDataM.unloginAgent}} </div></b-list-group-item>
									</b-list-group>
								</b-card-body>
							</b-collapse>	
						</footer>
					</b-card>

				</b-col>
				
				<!--<b-col class="px-2">
					<b-card img-src="" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Commission</h6>
						<b-card-text>{{$root.currency()+$root.tofixed('0',2)}}
						</b-card-text>
					</b-card>
				</b-col> -->
				<b-col lg="3" md="3" sm="6" class="px-2">
					<b-card img-src="" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Earning</h6>
						<b-card-text>{{$root.currency()+$root.tofixed('0',2)}}
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
			
			<b-row class="px-2">
				<b-col lg="6" md="6" sm="12" class="px-2">
						<!-- =================== Salses Summary =================== -->
						<b-card class="p-0">
							<div class="card-header border-0">
								<b-row  class=" align-items-center">
									<b-col cols="4"><h6 class="mb-0">Sales Summary </h6></b-col> 
									<b-col cols="7" class="p-0"><b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.daily">Today</b-button>
									<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.weekly">This Week</b-button>
									<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.monthly">This Month</b-button>
									<b-button class="rounded-pill fontSize9" size="sm" @click="summary_selected = summary.all">All</b-button></b-col>
									
									<b-col cols="1" class="text-right"><b-link block v-b-toggle.salseSummer variant="info"> <i class="fa fa-caret-down"></i> </b-link></b-col>
									</b-row>
							</div>
						
							<!--<template v-slot:header>
								<b-row>
									<b-col class="text-left">
										<h6 class="pt-1">Summary</h6>
									</b-col>
									<b-col class="text-right">
										<b-button class="mr-2 rounded-pill" size="sm">Data</b-button>
										<b-button class="rounded-pill" size="sm" >Chart 2</b-button>
									</b-col>
								</b-row>
							</template>-->
							<b-collapse id="salseSummer" visible accordion="my-salseSummer" role="tabpanel">
							<!-- <b-row class="mt-1 py-1">
								<b-col class="text-right">
									<b-button class="rounded-pill mr-2 " size="sm" @click="summary_selected = summary.daily">Today</b-button>
									<b-button class="rounded-pill mr-2" size="sm" @click="summary_selected = summary.weekly">This Week</b-button>
									<b-button class="rounded-pill mr-2" size="sm" @click="summary_selected = summary.monthly">This Month</b-button>
									<b-button class="rounded-pill" size="sm" @click="summary_selected = summary.all">All</b-button>
								</b-col>
							</b-row> -->
							<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
							<div class="hidden-columns"><div></div><div></div><div></div></div>
								<div class="el-table__body-wrapper is-scrolling-right">
									<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
										<colgroup>
											<col name="el-table_2_column_5" width="50%">
												<col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%">
										</colgroup> 
										<tbody>
											<tr class="el-table__row" >
												<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Sales</div></div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.sales[0]}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.sales[1], 2)}}</td>
											</tr>
											
											<tr class="el-table__row" >
												<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Orders</div></div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.orders[0]}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.orders[1] ? summary_selected.orders[1]: 0, 2)}}</td>
											</tr>
											
											<tr class="el-table__row" >
												<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Cancelled</div></div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.cancelled[0]}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.cancelled[1],2)}}</td>
											</tr>
											<tr class="el-table__row" >
												<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Fulfilled</div></div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.completed[0]}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.completed[1],2)}}</td>
											</tr>
											
												
										</tbody>
									</table>
							</div>
							<div class="el-table__column-resize-proxy" style="display: none;"></div>
											
							</div>
							
							<!-- <b-row class="mt-1 py-1" style="background-color:#f7f7f7">
								<b-col>Total Sales</b-col>
								<b-col class="text-right">{{summary_selected.sales[0]}}</b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed(summary_selected.sales[1], 2)}}</b-col>
							</b-row>
							<b-row>
								<b-col>Total Orders</b-col>
								<b-col class="text-right">{{summary_selected.orders[0]}}</b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed(summary_selected.orders[1] ? summary_selected.orders[1]: 0, 2)}}</b-col>
							</b-row>
							<b-row style="background-color:#f7f7f7">
								<b-col>Total Cancelled</b-col>
								<b-col class="text-right">{{summary_selected.cancelled[0]}}</b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed(summary_selected.cancelled[1],2)}}</b-col>
							</b-row>
							<b-row >
								<b-col>Total Fulfilled</b-col>
								<b-col class="text-right">{{summary_selected.completed[0]}}</b-col>
								<b-col class="text-right">{{$root.currency()+$root.tofixed(summary_selected.completed[1],2)}}</b-col>
							</b-row> -->
							</b-collapse>
						</b-card>

				
				<!-- ====================Products================================ -->
				
				
				<div class="card">
				<div class="card-header border-0"><div class="row align-items-center"><div class="col"><h6 class="mb-0">Products </h6></div><div class="text-right col"><b-link href="/admin/product-requests" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
										</b-link><b-link block v-b-toggle.productList variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link></div></div></div>
				<b-collapse id="productList" visible accordion="my-accordiond" role="tabpanel">
				<div class="card-body p-0">
					<!----><!---->
						<div class="el-table table-responsive table el-table--fit el-table--scrollable-x el-table--enable-row-hover el-table--enable-row-transition">
							<div class="hidden-columns"><div></div><div></div><div></div></div>
								
								<div class="el-table__body-wrapper is-scrolling-right">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
								<colgroup>
									<col name="el-table_2_column_5" width="80%">
										<col name="el-table_2_column_6" width="20%">
										<!-- <col name="el-table_2_column_7" width="220"> -->
								</colgroup> 
								<tbody>
									<tr class="el-table__row">
										<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600">Products Request</div></div></td>
										<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{total_products_request}}</div></td>
										
									</tr>
										
									<tr class="el-table__row"><td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600">Products Approved</div></div></td>
									<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{total_products_approved}}</div></td>
									</tr>
									
									<tr class="el-table__row"><td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600">Product-rejected</div></div></td>
									<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{total_products_rejected}}</div></td>
									</tr>
									
									
								<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
								<div class="el-table__column-resize-proxy" style="display: none;"></div>
								
								</div>
								
								</div>
							</b-collapse>	
								
						</div>
					<!-- ========================Wallet Status============================================= -->	
					<b-card class="p-0">
						<div class="card-header border-0">
							<b-row class="align-items-center">
								<b-col cols="3"><h6 class="mb-0">Wallet Status </h6></b-col>
								<b-col cols="7" class="p-0">
								<b-row >
									<b-col class="text-left pr-0">
										
										<b-form-datepicker id="datepicker-from" v-model="datefrom" class="mb-2" placeholder="Start" @input="initloadWalletCal()" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" reset-button></b-form-datepicker>
									</b-col>
									<b-col  class="text-left pl-1">
										
										<b-form-datepicker id="datepicker-to" v-model="dateto" class="mb-2" placeholder="End" @input="initloadWalletCal()" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" reset-button></b-form-datepicker>
									</b-col>
									<!--<b-col lg="2" class="text-left">
										<b-button pill variant="primary"  @click="initloadWalletExpense()" size="sm" >GO</b-button>
									</b-col> -->
								</b-row>
								
									
								
								</b-col>
								<b-col cols="2" class="text-right" ><b-link href="/admin/wallet/transactionHistory" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
										</b-link><b-link block v-b-toggle.walletSummery variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link>
								</b-col>
							</b-row>
						</div>
						<b-collapse id="walletSummery" visible accordion="my-walletSummery" role="tabpanel">
					
					
						<b-row class="mt-1 px-3">
							<b-col   class="text-left p-0">
								<b-table-simple  small caption-top responsive>
									<!--<caption></caption>-->
									<b-thead head-variant="light">
										<b-tr>
											<b-th >Wallet For</b-th>
											<b-th class="text-right">Total Transfer</b-th>
											<b-th class="text-right">Total Expired</b-th>
											<b-th class="text-right">Available Balance</b-th>
											<b-th class="text-right">Total Used</b-th>
										</b-tr>
									</b-thead> 
									<b-tbody>
										<b-tr>
											<b-th>Seller </b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerCr, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerEx, 2)}}</b-th>
											
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerBalance, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(sellerData.sellerUsed, 2)}}</b-th>
										</b-tr>
										<b-tr>
											<b-th>{{$root.INFLUENCER_TEXT}} </b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentCr, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentEx, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentBalance, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(agentData.agentUsed, 2)}}</b-th>
										</b-tr>
										<b-tr>
											<b-th>Customer </b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerCr, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerEx, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerBalance, 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(customerData.customerUsed, 2)}}</b-th>
										</b-tr>
										
								   </b-tbody>
								   <b-tfoot head-variant="light">
										<b-tr style="border-top:1px solid #c6c6c6;background-color: #c6c6c624;">
											<b-th >Row Total</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerCr)+Number(agentData.agentCr)+Number(customerData.customerCr), 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerEx)+Number(agentData.agentEx)+Number(customerData.customerEx), 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerBalance)+Number(agentData.agentBalance)+Number(customerData.customerBalance), 2)}}</b-th>
											<b-th class="text-right">{{$root.currency()+ $root.tofixed(Number(sellerData.sellerUsed)+Number(agentData.agentUsed)+Number(customerData.customerUsed), 2)}}</b-th>
										</b-tr>
									</b-tfoot> 
								</b-table-simple>
							</b-col>
									
						</b-row>
						</b-collapse>
					</b-card>
					
						<b-card class="p-0">
							<div class="card-header border-0">
								<b-row class="align-items-center">
									<b-col cols="4"><h6 class="mb-0">Referral Status </h6></b-col>
									<b-col cols="7" class="p-0">
									<b-row>
										<b-col class="text-left p-0">
											
											<b-form-datepicker id="datepickert-from" v-model="dateReffrom" class="mb-2" placeholder="Start" @input="initloadReferralCal()" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" reset-button></b-form-datepicker>
										</b-col>
										<b-col  class="text-left pl-1">
											
											<b-form-datepicker id="datepickert-to" v-model="dateRefto" class="mb-2" placeholder="End" @input="initloadReferralCal()" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" reset-button></b-form-datepicker>
										</b-col> 
									</b-row>
									
										
									
									</b-col>
									<b-col cols="1" class="text-right" ><b-link block v-b-toggle.referralSummery variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link>
									</b-col>
								</b-row>
							</div>
							<b-collapse id="referralSummery" visible accordion="my-referralSummery" role="tabpanel">
									
							<b-row class="mt-1 px-3">
								<b-col class="text-left p-0">
									<b-table-simple  small caption-top responsive>
										<!--<caption></caption>-->
										<b-thead head-variant="light">
											<b-tr>
												<b-th >&nbsp;</b-th>
												<b-th class="text-right">Total</b-th>
												<b-th class="text-right">Sellers</b-th>
												<b-th class="text-right">{{$root.INFLUENCER_TEXT}}</b-th>
												<b-th class="text-right">Customers</b-th>
											</b-tr>
										</b-thead> 
										<b-tbody>
											<b-tr>
												<b-th>Referral - Signup </b-th>
												<b-th class="text-right">{{signups}}</b-th>
												<b-th class="text-right">{{sellersRef}}</b-th>
												<b-th class="text-right">{{salesadvisorsRef}}</b-th>
												<b-th class="text-right">{{customersrsRef}}</b-th>
												
							
											</b-tr>
											<b-tr>
												<b-th>Referral - Earned</b-th>
												<b-th class="text-right">{{$root.currency()}}{{earned}}</b-th>
												<b-th class="text-right">{{$root.currency()}}{{sellersRef*150}}</b-th>
												<b-th class="text-right">{{$root.currency()}}{{salesadvisorsRef*150}}</b-th>
												<b-th class="text-right">{{$root.currency()}}{{customersrsRef*150}}</b-th>
											</b-tr>
									   </b-tbody>
									   
									</b-table-simple>
								</b-col>
										
							</b-row>


						
							</b-collapse>
						</b-card>



			
				</b-col>
				<b-col lg="6" md="6" sm="12">
						<div class="card"><!---->
						<div class="card-header border-0">
							<b-row class=" align-items-center">
							<b-col  lg="4" md="4" sm="12"><h6 class="mb-0">Seller Agreement</h6></b-col>
							<b-col lg="6" md="4" sm="8" class="text-center">
							<b-badge pill variant="danger" @click="setAggrimetList(0)" class="fontSize9">Waiting</b-badge> <b-badge pill variant="success" @click="setAggrimetList(1)" class="fontSize9" >Approved</b-badge> </b-col>
						<b-col lg="2" md="4" sm="4" class="text-right col">
						
							<b-link href="/admin/sellers" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
								</b-link><b-link block v-b-toggle.sellerAgreement variant="info"><i class="fa fa-caret-down ml-2"></i> </b-link>
						</b-col></b-row>
						</div>
						<b-collapse id="sellerAgreement" visible accordion="my-sellerAgreement" role="tabpanel">
							<div class="card-body p-0">
							<!----><!---->
								<div class="el-table table-responsive table el-table--fit el-table--scrollable-x el-table--enable-row-hover el-table--enable-row-transition">
									<div class="hidden-columns"><div></div><div></div><div></div></div>
									<div class="el-table__header-wrapper">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
										<colgroup>
											<col name="el-table_2_column_5" width="30%">
											<col name="el-table_2_column_5" width="30%">
											<col name="el-table_2_column_6" width="20%">
											<col name="el-table_2_column_7" width="20%">
											<col name="gutter" width="0"></colgroup>
												<thead class="has-gutter">
													<tr class="thead-light">
													<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">Name</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">Email</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">Status</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Action</div></th>
													</tr>
												</thead>
											</table>
										</div>
										<div class="el-table__body-wrapper is-scrolling-right">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
										<colgroup>
											<col name="el-table_2_column_5" width="30%">
											<col name="el-table_2_column_6" width="30%">
											<col name="el-table_2_column_6" width="20%">
											<col name="el-table_2_column_7" width="20%">
										</colgroup> 
										<tbody>
											<tr class="el-table__row"  v-for="itemLi in agreementSellerList" :key="itemLi.id">
												<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{itemLi.username}}</div></div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{itemLi.email}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{agreementSellerStatus}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_7 ">View</td>
												</tr>
											
										
											
										<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
										<div class="el-table__column-resize-proxy" style="display: none;"></div>
										
										</div>
										
										</div>
									</b-collapse>	
									
							</div>
						<div class="card"><!---->
						<div class="card-header border-0"><div class="row align-items-center"><div class="col"><h6 class="mb-0">Active Users</h6></div><div class="text-right col">
									<b-link href="/admin/sellers" style="font-size:12px;">
										<b-iconstack style="font-size:12px;">
										  <b-icon stacked icon="square"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3"></b-icon>
										  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
										</b-iconstack>
								</b-link><b-link block v-b-toggle.activeUser variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link></div></div></div>
						<b-collapse id="activeUser" visible accordion="my-activeUser" role="tabpanel">
							<div class="card-body p-0">
							<!----><!---->
								<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
									<div class="hidden-columns"><div></div><div></div><div></div></div>
									<div class="el-table__header-wrapper">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
										<colgroup><col name="el-table_2_column_5" width="50%"><col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%"><col name="gutter" width="0"></colgroup>
												<thead class="has-gutter">
													<tr class="thead-light">
													<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">User Name</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">Type</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Last login</div></th>
													</tr>
												</thead>
											</table>
										</div>
										<div class="el-table__body-wrapper is-scrolling-right">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
										<colgroup>
											<col name="el-table_2_column_5" width="50%">
												<col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%">
										</colgroup> 
										<tbody>
											<tr class="el-table__row"  v-for="itemAcUse in activeUsers" :key="itemAcUse.id">
												<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{itemAcUse.username}}</div></div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{rolesList[itemAcUse.role]=='Sales-advisor'?$root.INFLUENCER_TEXT:rolesList[itemAcUse.role]}}</div></td>
												<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$moment(itemAcUse.insert_time).format('DD-MM-YYYY')}}</td>
											</tr>
											
										<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
										<div class="el-table__column-resize-proxy" style="display: none;"></div>
										
										</div>
										
										</div>
									</b-collapse>	
									
							</div>
							<!--<b-link @click="autodebtest()">Click me Wallet</b-link>  -->
				</b-col>
				
			</b-row>
			
		</b-container>
		
		<top-footer></top-footer>
		</b-col>
		</b-row>
			
		</b-container>
		
		
	</div>
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		this.initload();
		this.initloadWalletExpense();
		this.initloadReferralExpense();
		
	},
	data() {
		return{
			total_seller: 0,
			total_agent: 0,
			total_products_request: 0,
			total_products_approved:0,
			total_products_rejected:0,
			url: this.$root.WEBAPI+'secureapi/dashboard',
			recordAutoDebitUrl: this.$root.WEBAPI+'walletapi/autoDebitWalletamount',
			sellerMarkating:{
				activeSeller:0,
				deactiveSeller:0,
				newSeller: 0,
				totalSeller:0
			},
			agentMarkating:{
				activeAgent:0,
				deactiveAgent:0,
				newAgent: 0,
				totalAgent:0,
				unloginAgent:0
			},
			customerDataM:{
				totalCustomer:0,
				unloginAgent:0
			},
			activeUsers:[],
			rolesList:{2:'Seller',3:'Sales-advisor',4:'Customer'},
			
			/*wallet Expanses*/
			walletExpenseUrl: this.$root.WEBAPI+'walletapi/walletExpense',
			referralDetailsUrl: this.$root.WEBAPI+'walletapi/referralDetails',
			datefrom: '',
			dateto: '',
			agentData :[],
			customerData :[],
			sellerData  :[],
			/* Seller Data */
			summary_selected: {
				sales: [0,0],
				orders: [0,0],
				cancelled: [0,0],
				completed: [0,0]
			},
			summary: {},
			
			agreementSeller:{wallting:[],approved:[]},
			agreementSellerList:{},
			agreementSellerStatus:'Waiting',
			signups:0,
			earned:0,
			customersrsRef:0,
			salesadvisorsRef:0,
			sellersRef:0,
			dateReffrom: '',
			dateRefto: '',
			
		};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.total_seller = response.data.result.total_seller;
					self.total_agent = response.data.result.total_agent;
					self.total_products_request = response.data.result.total_products_request;
					self.total_products_approved = response.data.result.total_products_approved;
					self.total_products_rejected = response.data.result.total_products_rejected;
					self.agreementSeller = response.data.result.agreementSeller;
					self.agreementSellerList = self.agreementSeller.watting;
					
					var activeUsers = response.data.result.activeUsers;
					
					activeUsers.forEach(item => {
							
						if(item.role>1){						
							self.activeUsers.push(item);
						}
					});
					
					
					self.sellerMarkating = response.data.result.sellerMarkating;
					self.agentMarkating = response.data.result.agentMarkating;
					self.customerDataM = response.data.result.customerData;
					self.summary = response.data.result.summary;
					self.summary_selected = self.summary.daily;
					
					/*

					self.dashboard_data = response.data.result;
					self.records = response.data.result.records;
					self.zones = response.data.result.zones;*/

				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			
			
		},
		initloadWalletCal(){
			var self = this;
			//console.log('CCGG');
			if(self.datefrom!=0 && self.dateto!=0){
				self.initloadWalletExpense();
			}
			
		},
		initloadWalletExpense(){
				var self = this;

				self.axios.post(self.walletExpenseUrl, {
					accesskey: self.$session.get('access_key'),
					datefrom: self.datefrom,
					dateto: self.dateto,
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
					
						//console.log(response.data.result);
						self.agentData  = response.data.result.agentData;
						self.customerData  = response.data.result.customerData;
						self.sellerData  = response.data.result.sellerData;
						

						/* self.walletRecord = response.data.result;
						self.blance		=	response.data.result.blance;
						self.cr_amount	=	response.data.result.cr_amount;
						self.dr_amount	=	response.data.result.dr_amount;
						self.transaction	=	response.data.result.transaction;
						
						
						
						self.records =response.data.result.transaction;
						//self.records.options = JSON.parse(self.records.options);
						//self.usersRoles = response.data.result.usersRoles;
						self.loading = false;
						self.totalRows = self.records.length;
						//console.log(self.share_data); */
					}else if(response.data.error == 9){
						self.$root.forceLogout(response.data.message);
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			
		},
		initloadReferralCal(){
			var self = this;
			//console.log('CCGG');
			if(self.dateReffrom!=0 && self.dateRefto!=0){
				self.initloadReferralExpense();
			}
			
		},
		initloadReferralExpense(){
				var self = this;

				self.axios.post(self.referralDetailsUrl, {
					accesskey: self.$session.get('access_key'),
					datefrom: self.dateReffrom, 
					dateto: self.dateRefto,
					
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
					
						//console.log(response.data.result);
						self.signups  = response.data.result.signups;
						self.earned  = response.data.result.earned;
						self.customersrsRef  = response.data.result.customersrsRef;
						self.salesadvisorsRef  = response.data.result.salesadvisorsRef;
						self.sellersRef  = response.data.result.sellersRef;
						
						
					
					}else if(response.data.error == 9){
						self.$root.forceLogout(response.data.message);
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			
			},
			setAggrimetList(valA){
				var self = this;
				if(valA==1){
					self.agreementSellerList = self.agreementSeller.approved;
					self.agreementSellerStatus='Approved';
				}else{
					self.agreementSellerList = self.agreementSeller.watting;
					self.agreementSellerStatus='Waiting';
				}
			},
			autodebtest(){
				console.log('ddd');
				var self =this;
				self.axios.post(self.recordAutoDebitUrl, {
					accesskey: self.$session.get('access_key')
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						console.log(response);
						
						
					}else if(response.data.error == 9){
						self.$root.forceLogout(response.data.message);
					}
					
				})
				.catch(function (error) {
					alert(error);
				});  
			}
			

		}
}
</script>
<style scoped lang="scss">
.dashboard{
	.borderLeft{
		border-left: 1px solid #c6c6c682;
	}
	.list-group{
		&-item{
			padding:5px;
			font-size:12px;
			.textCount{float: right;
						width: 50%;}
		}
	}
	.fontSize9{font-size: 9px;}
}
</style>